export const POWERPLUG_CODE_PREFIXES = {
  AFIB: 'AF',
  CARDIO: 'CA',
  CNO_PRO: 'OP',
  CNO_WELLNESS: 'OW',
  RESPIRATORY: 'RH',
  LES_MILLS: 'LM',
} as const;

export const POWERPLUG_CODE_PLACEHOLDER = 'XX-XXXXX';
export const POWERPLUG_CODE_LENGTH = 7;

export type PowerPlugCodePrefix =
  (typeof POWERPLUG_CODE_PREFIXES)[keyof typeof POWERPLUG_CODE_PREFIXES];

export const CONSENT_REQUIRED_PREFIXES: PowerPlugCodePrefix[] = [
  POWERPLUG_CODE_PREFIXES.AFIB,
  POWERPLUG_CODE_PREFIXES.CARDIO,
];

export const TERMS_OF_USE_URL =
  'https://ultrahumanapp.notion.site/TERMS-OF-USE-7a541a34b77b4cb79566a327578873bb';

export const PRIVACY_POLICY_URL =
  'https://ultrahumanapp.notion.site/PRIVACY-POLICY-16dccc2b1b2b4c4bb9a462c155b3bef1';

export function normalizePurchaseCode(purchaseCode: string): string {
  return purchaseCode.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
}

export function isValidPowerPlugCodeFormat(purchaseCode: string): boolean {
  const normalized = normalizePurchaseCode(purchaseCode);
  return normalized.length === POWERPLUG_CODE_LENGTH;
}

export function getPurchaseCodeForApi(purchaseCode: string): string {
  const normalized = normalizePurchaseCode(purchaseCode);
  return `${normalized.slice(0, 2)}-${normalized.slice(2)}`;
}

export function getCodePrefix(purchaseCode: string): string {
  return normalizePurchaseCode(purchaseCode).slice(0, 2);
}

export function requiresConsent(purchaseCode: string): boolean {
  const prefix = getCodePrefix(purchaseCode);
  return CONSENT_REQUIRED_PREFIXES.includes(prefix as PowerPlugCodePrefix);
}

export type ConsentPlugType = 'afib' | 'cardio';

export function getConsentPlugType(purchaseCode: string): ConsentPlugType | null {
  const prefix = getCodePrefix(purchaseCode);
  if (prefix === POWERPLUG_CODE_PREFIXES.AFIB) return 'afib';
  if (prefix === POWERPLUG_CODE_PREFIXES.CARDIO) return 'cardio';
  return null;
}
